import React, { useState } from 'react';
import { Box } from '@mui/material';
import { usePagination } from 'hooks';
import {
	ItemsPerPageSelect,
	PageRange,
} from 'components/base/pagination/components';

interface PaginationProps {
	totalItemCount: number | undefined;
	currentDisplayedPage: number;
	onPageChange: (page: number, size: number) => void;
	pageSizeOptions: number[];
	defaultPageSize?: number;
	siblingCount?: number;
	boundaryCount?: number;
	wrapperClass?: string;
	pageRangeClass?: string;
	pageSizeSelectClass?: string;
	currentPageSize?: number;
	onPageSizeChange?: (size: number) => void;
}

export const Pagination = ({
	totalItemCount = 0,
	currentDisplayedPage,
	onPageChange,
	pageSizeOptions,
	defaultPageSize,
	siblingCount = 1,
	boundaryCount = 1,
	wrapperClass,
	pageRangeClass,
	pageSizeSelectClass,
	currentPageSize,
	onPageSizeChange,
}: PaginationProps) => {
	const [pageSize, setPageSize] = useState(
		defaultPageSize || pageSizeOptions[0],
	);
	const currentSize = currentPageSize || pageSize;
	const totalPageCount = Math.ceil(totalItemCount / currentSize);

	const paginationRange = usePagination({
		totalPageCount,
		currentPage: currentDisplayedPage,
		siblingCount,
		boundaryCount,
	});

	const changePageNumber = (page: number) => {
		onPageChange(page, currentSize);
	};

	const changePageSize = (size: number) => {
		const viewedItemsCount =
			currentDisplayedPage * currentSize > totalItemCount
				? totalItemCount
				: currentDisplayedPage * currentSize;
		const newCurPage = Math.ceil(viewedItemsCount / size);
		onPageChange(newCurPage, size);
		onPageSizeChange ? onPageSizeChange(size) : setPageSize(size);
	};

	if (
		!currentDisplayedPage ||
		(currentSize === pageSizeOptions[0] && paginationRange.length < 2)
	)
		return null;

	return (
		<Box
			className={wrapperClass}
			display="flex"
			justifyContent="flex-end"
			flexWrap="wrap"
		>
			<ItemsPerPageSelect
				pageSizeOptions={pageSizeOptions}
				itemsPerPage={currentSize}
				changeItemsPerPage={changePageSize}
				wrapperClass={pageSizeSelectClass}
			/>
			<PageRange
				wrapperClass={pageRangeClass}
				currentPage={currentDisplayedPage}
				paginationRange={paginationRange}
				onPageChange={changePageNumber}
			/>
		</Box>
	);
};
